var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockCombinationKeyRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "24px",
    viewBox: "0 0 29 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock_combination_key_icon",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ctrl",
    transform: "translate(2.009436, 1.782609)",
    fill: "#FF9E40",
    fillRule: "nonzero",
    fontFamily: "Avenir-Black, Avenir",
    fontSize: 5,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5
  }, "Ctrl"))), /*#__PURE__*/React.createElement("g", {
    id: "Z",
    transform: "translate(19.717082, 12.217391)",
    fill: "#FF9E40",
    fillRule: "nonzero",
    fontFamily: "Avenir-Black, Avenir",
    fontSize: 6,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6
  }, "Z"))), /*#__PURE__*/React.createElement("path", {
    d: "M26.5176823,10.2274245 L26.5176823,9.695652 C26.5176823,8.03879775 25.1745365,6.695652 23.5176823,6.695652 L13.6496163,6.695652 C11.992762,6.695652 10.6496163,8.03879775 10.6496163,9.695652 L10.6496163,18.9999998 C10.6496163,20.656854 11.992762,21.9999998 13.6496163,21.9999998 L17.618132,21.9999998 L17.618132,21.9999998",
    id: "Path-9",
    stroke: "#FF9E40",
    strokeWidth: 2,
    transform: "translate(18.583649, 14.347826) rotate(180.000000) translate(-18.583649, -14.347826) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.868066,3.53177258 L15.868066,3 C15.868066,1.34314575 14.5249202,0 12.868066,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,12.3043478 C0,13.9612021 1.34314575,15.3043478 3,15.3043478 L7.93403299,15.3043478 L7.93403299,15.3043478",
    id: "Path-9",
    stroke: "#FF9E40",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.713051, 4.782609)",
    fill: "#FF9E40",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock-outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.34482759,8.60869565 C3.80896552,8.60869565 3.37931034,8.17826087 3.37931034,7.65217391 C3.37931034,7.12130435 3.80896552,6.69565217 4.34482759,6.69565217 C4.87806803,6.69565217 5.31034483,7.12390154 5.31034483,7.65217391 C5.31034483,8.18044628 4.87806803,8.60869565 4.34482759,8.60869565 M6.75862069,9.56521739 L6.75862069,5.73913043 L1.93103448,5.73913043 L1.93103448,9.56521739 L6.75862069,9.56521739 M7.72413793,3.82608696 C8.33355559,3.82608696 8.82758621,4.31551481 8.82758621,4.91925466 L8.82758621,10.3850932 C8.82758621,10.988833 8.33355559,11.4782609 7.72413793,11.4782609 L1.10344828,11.4782609 C0.491034483,11.4782609 2.08259279e-25,10.9863354 2.08259279e-25,10.3850932 L2.08259279e-25,4.91925466 C2.08259279e-25,4.31254658 0.491034483,3.82608696 1.10344828,3.82608696 L1.65517241,3.82608696 L1.65517241,2.73291925 C1.65517241,1.22356963 2.89024897,0 4.4137931,0 C5.1454248,0 5.84709077,0.287931738 6.3644325,0.800453517 C6.88177423,1.3129753 7.17241379,2.008104 7.17241379,2.73291925 L7.17241379,3.82608696 L7.72413793,3.82608696 M4.44137931,1.43478261 C3.64151864,1.43478261 2.99310345,2.07715666 2.99310345,2.86956522 L2.99310345,3.82608696 L5.88965517,3.82608696 L5.88965517,2.86956522 C5.88965517,2.07715666 5.24123998,1.43478261 4.44137931,1.43478261 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCombinationKeyRed);
export default __webpack_public_path__ + "static/media/lock_combination_key_red.d4b322697fb4d6aa752f51eec8612a87.svg";
export { ForwardRef as ReactComponent };